import { rootLogger } from '@/lib/root-logger';

const moduleLogger = rootLogger.child({ module: 'FormattedDate' });

type Props = {
  date: string;
};

export function FormattedDate(props: Props) {
  const date = new Date(props.date);

  const { isoString, formattedDate } = (() => {
    try {
      if (date.toString() === 'Invalid Date') {
        return { isoString: undefined, formattedDate: '' };
      }

      const isoString = date.toISOString();
      const formattedDate = date.toLocaleDateString('en-us', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });

      return { isoString, formattedDate };
    } catch (error) {
      moduleLogger.error(
        {
          date,
          error,
        },
        'Error formatting date',
      );

      return { isoString: undefined, formattedDate: '' };
    }
  })();

  return <time dateTime={isoString}>{formattedDate}</time>;
}
